import axios from "axios";
import { GET_SEARCH_RESULT_V2_ROUTE } from "./apiRoutes";

const getSearchResultV2 = (params) => {
  const postData = new FormData();

  // IMPORTANT: stringify the params object to send as string
  postData.append("params", JSON.stringify(params));

  // Do NOT set Content-Type here — axios sets it automatically for FormData
  return axios
    .post(GET_SEARCH_RESULT_V2_ROUTE, postData)
    .then((response) => response)
    .catch((error) => false);
};

export default getSearchResultV2;
